import EFPicture from '@elem/compCommon/EFPicture';
import { IPageStatus } from '@elem/compPage/DP3/components/IPageStatus';
import { FC } from 'react';
import { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useDP3Store } from '../../DP3Provider';
import AC from './icons/AC';
import Heater from './icons/Heater';
import Microwave from './icons/Microwave';
import Oven from './icons/Oven';
import Desktop from './icons/Desktop';
import RiceCooker from './icons/RiceCooker';
import Pump from './icons/Pump';
import Refrigerator from './icons/Refrigerator';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const TheComp: FC = () => {
    const { pageStatus } = useDP3Store();
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const IS_EU_SITES = ['eu', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);
    const { t } = useLang(IS_EU_SITES ? 'dp3.landing.Freedom' : 'dp3.teaser.Freedom');
    const { t: t1 } = useLang('dp3.landing.CommonTexts');

    const Icons = [
        { icon: <Pump /> },
        { icon: <AC /> },
        { icon: locale === 'ph' ? <Desktop /> : <Oven /> },
        { icon: locale === 'ph' ? <RiceCooker /> : <Heater /> },
        { icon: <Microwave /> },
        { icon: <Refrigerator /> },
    ];

    const cards = [
        {
            title: t('card1_title'),
            apps: [t('card1_app1_text'), t('card1_app2_text'), t('card1_app3_text'), t('card1_app4_text'), t('card1_app5_text'), t('card1_app6_text')],
            src: IS_EU_SITES
                ? 'https://websiteoss.ecoflow.com/upload/image/1725349502066/dp3_eu%20(1).png'
                : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717503264531/c13.png',
            // srcMobile: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717503264531/c13.png',
        },
        {
            title: t('card2_title'),
            apps: [t('card2_app1_text'), t('card2_app2_text'), t('card2_app3_text'), t('card2_app4_text'), t('card2_app5_text'), t('card2_app6_text')],
            desc: t('card2_memo'),
            desc2: t('card2_memo2'),
            src: IS_EU_SITES
                ? 'https://websiteoss.ecoflow.com/upload/image/1725013182651/sl_DP3_Bundle.png'
                : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717397197128/capacity_pc_2.png',
            srcMobile: IS_EU_SITES
                ? 'https://websiteoss.ecoflow.com/upload/image/1725013182651/sl_DP3_Bundle.png'
                : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717503310598/c14.png',
        },
        {
            title: t('card3_title'),
            desc: t('card3_memo'),
            src: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717397117984/capacity_pc_3.png',
            srcMobile: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717503362035/c15.png',
        },
    ];

    if (IS_EU_SITES) {
        cards.pop();
        cards[1].apps.pop();
    }

    return (
        <div id="dp3-teaser-H" className={`${css['theComp']} Freedom dp3-teaser-H`}>
            <div className="dp3-spec"></div>
            {IS_EU_SITES ? (
                <div className="info-box">
                    <p className="title">{t('title')}</p>
                    <p className="desc">{t('desc')}</p>
                    <p className="tip">{t('tip')}</p>
                </div>
            ) : (
                <>{pageStatus === IPageStatus.statusB && <div className="dp3-title">{t1('Freedom_title')}</div>}</>
            )}

            <Swiper
                className={`swiper-box`}
                modules={[Scrollbar, Navigation, Pagination, Autoplay]}
                navigation={true}
                pagination={true}
                loop={true}
                spaceBetween={0}
                // autoplay={{
                //     delay: 3000,
                //     disableOnInteraction: false,
                //     pauseOnMouseEnter: true,
                // }}
                centeredSlides={true}
                slidesPerView={'auto'}
                initialSlide={0}
            >
                {cards?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item`} key={k}>
                        <div className="card-info">
                            <p className="card-title">{card.title}</p>
                            {card?.apps?.length > 0 && (
                                <ul className="card-apps">
                                    {card?.apps?.map((app: any, m: number) => (
                                        <li className="card-app" key={`${k}_${m}`}>
                                            <div className="app-icon">{Icons[m].icon}</div>
                                            <p className="app-text">{t(`card_app_${m + 1}`)}</p>
                                            <p className="app-text">{app}</p>
                                        </li>
                                    ))}
                                </ul>
                            )}
                            {card?.desc2 && <p className="card-desc">{card?.desc2}</p>}
                            {card?.desc && <p className="card-desc card-desc2">{card?.desc}</p>}
                        </div>
                        <div className="card-img">
                            <EFPicture src={card.src} srcPad={card?.srcMobile} srcMobile={card?.srcMobile} alt={card.title} />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default TheComp;
